export default __webpack_public_path__ + "static/image-8c9d8a99e2f37f62d3e2384289a3d6e0.png";